import { render } from "./verifyandchangeemail.vue?vue&type=template&id=d16cc2e0&scoped=true"
import script from "./verifyandchangeemail.vue?vue&type=script&lang=js"
export * from "./verifyandchangeemail.vue?vue&type=script&lang=js"

import "./verifyandchangeemail.vue?vue&type=style&index=0&id=d16cc2e0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16cc2e0"]])

export default __exports__